import { render } from "./IABanner.vue?vue&type=template&id=68af47e2&scoped=true"
import script from "./IABanner.vue?vue&type=script&lang=js"
export * from "./IABanner.vue?vue&type=script&lang=js"

import "./IABanner.vue?vue&type=style&index=0&id=68af47e2&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68af47e2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
